import { all, call, takeLatest } from 'redux-saga/effects';

import {
  loadChatAnnouncements,
  createChatAnnouncement,
  editChatAnnouncement,
  deleteChatAnnouncement,
  sendChatAnnouncement,
  getSystemUser,
} from 'api/chats';
import { CHATS_ACTION_TYPES } from '../actions/chats.actions';
import { getRangeDate } from '../../utils/dateHelpers';

function* loadChatMailingsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    let { age, date, sent, ...filters } = payload;
    if (age) {
      filters = {
        ...filters,
        'age_min': age?.[0],
        'age_max': age?.[1],
      };
    }
    if (sent) {
      filters = {
        ...filters,
        sent: sent?.[0] ? 1 : 0
      };
    }
    if (date) {
      filters = {
        ...filters,
        ...getRangeDate('date', date),
      }
    }
    const { data } = yield call(loadChatAnnouncements, filters);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e);
  }
}

function* createChatMailingFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(createChatAnnouncement, payload);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editChatMailingFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { id, ...data } = payload;
    const { data: response } = yield call(editChatAnnouncement, id, data);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* submitChatMailingFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(sendChatAnnouncement, payload);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteChatMailingsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(deleteChatAnnouncement, payload);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

function* loadSystemUserFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data: response } = yield call(getSystemUser);
    resolve(response);
  } catch (e) {
    reject(e.response.data);
  }
}

export default function* () {
  yield all([
    takeLatest(CHATS_ACTION_TYPES.LOAD_CHAT_MAILINGS, loadChatMailingsFlow),
    takeLatest(CHATS_ACTION_TYPES.CREATE_CHAT_MAILING, createChatMailingFlow),
    takeLatest(CHATS_ACTION_TYPES.EDIT_CHAT_MAILING, editChatMailingFlow),
    takeLatest(CHATS_ACTION_TYPES.SUBMIT_CHAT_MAILING, submitChatMailingFlow),
    takeLatest(CHATS_ACTION_TYPES.DELETE_CHAT_MAILING, deleteChatMailingsFlow),
    takeLatest(CHATS_ACTION_TYPES.LOAD_SYSTEM_USER, loadSystemUserFlow),
  ]);
}